import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../tabs/css/Loader.css";

const BOOT_LINES = [
  "> INITIALIZING SYSTEM...",
  "> LOADING PORTFOLIO v2.0",
  "> CONNECTING TO SERVERS...",
  "> ACCESS GRANTED",
];

export default function Loader() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep(prev => {
        if (prev >= BOOT_LINES.length) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 380);
    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="loader"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ delay: 1.9, duration: 0.4 }}
    >
      <div className="loader-content">
        <div className="loader-logo">
          FN<span>.</span>
        </div>
        <div className="loader-terminal">
          {BOOT_LINES.slice(0, step).map((line, i) => (
            <div key={i} className="loader-line">{line}</div>
          ))}
          {step < BOOT_LINES.length && (
            <span className="loader-cursor">_</span>
          )}
        </div>
        <div className="loader-bar-track">
          <div
            className="loader-bar"
            style={{ width: `${(step / BOOT_LINES.length) * 100}%` }}
          />
        </div>
        <div className="loader-pct">{Math.round((step / BOOT_LINES.length) * 100)}%</div>
      </div>
    </motion.div>
  );
}
